import React from "react";

const LazyVoteRedirect = React.lazy(() => import("./VoteRedirect").then((m) => ({ default: m.VoteRedirect })));

export default LazyVoteRedirect;
